import { DatePicker, DateTimePicker } from '@progress/kendo-react-dateinputs';
import { Field, FormElement } from '@progress/kendo-react-form';
import { Input } from '@progress/kendo-react-inputs';
import { Error, Label } from '@progress/kendo-react-labels';
import moment from 'moment';
import * as React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useConfiguration from '../../../../hooks/useConfiguration';
import {
  getEncounterRate,
  getZipCodeInfo,
} from '../../../JobOpportunity/action';
import {
  AppointmentType,
  PhoneNumberInput,
  ShiftLength,
  ShowMap,
  ZipCodeInput,
} from './editors';
import * as Toasts from '../../../common/Toastify';

export const CustomFormEditor = (props) => {
  const dispatch = useDispatch();
  const config = useConfiguration();
  const locationNameInfo = useSelector(
    (state) => state.jobOpportunity.location.locationNameInfo
  );
  const jobCategory = useSelector(
    (state) => state.jobOpportunity.jobInfo.jobCategory
  );
  const jobInfoForDailyOccurance = useSelector(
    (state) => state.shiftsCoverage.jobInfoForDailyOccurance
  );
  const appointmentData = useSelector(state => state.jobOpportunity.appointmentData)
  const shiftLengthData = useSelector(
    (state) => state.jobOpportunity.shiftLengthData
  );
  const shiftLength = props.valueGetter('ShiftLength') ?? 15
  const start = props.valueGetter('Start');
  const end = props.valueGetter('End')
  // const changeShiftLength = () => {
  //   const start = moment(props.valueGetter('Start'));
  //   const end = moment(props.valueGetter('End'));
  //   const diff = end.diff(start, 'minutes');
  //   // console.log(`🚀 ~ file: custom-form-editor.jsx ~ line: 22 :`, {
  //   //   start,
  //   //   end,
  //   //   diff,
  //   // });
  //   props.onChange('ShiftLength', {
  //     value: diff,
  //   });
  // };

  useEffect(() => {
    const appointmentType = props.valueGetter('AppointmentType');
      if (appointmentType && config.baseUrl && !props.valueGetter('billingRate')) {
        billingRate()
      }
  }, [config.baseUrl])
  
  

  // const changeEndDate = () => {
  //   const start = props.valueGetter('Start');
  //   const shiftLength = props.valueGetter('ShiftLength') ?? 15;
  //   console.log({shiftLength});
  //   const end = moment(start).add(shiftLength, 'minutes').format();
  //   console.log({end});
  //   props.onChange('End', {
  //     value: new Date(end),
  //   });
  // };
   const updateShiftTime = ({currentValue,updateField,shiftStartTime,masterData}) => {
    if(updateField === "ShiftLength"){
        const startTime = moment(shiftStartTime, 'hh:mm');
        const endTime = moment(currentValue, 'hh:mm');
        const InMinutes = moment.duration(endTime.diff(startTime)).asMinutes();
        const result = masterData?.find(item => item?.id === InMinutes);
        const lastItem = masterData.at(-1)
        let updatePreferredShift;
        if(result){
            updatePreferredShift = result?.id
        } else if(InMinutes > lastItem?.id){
            updatePreferredShift = lastItem?.id
        }
        if(updatePreferredShift){
          props.onChange(updateField, {
            value:updatePreferredShift,
          });
        }
    }
    if(updateField === "End"){
      const hours = Math.floor(parseInt(shiftLength) / 60);
      const minutes = parseInt(parseInt(shiftLength) ) % 60;
      const actualEndTime = moment(shiftStartTime).add(hours, 'hours')
      .add(minutes, 'minute')
      if(actualEndTime){
        props.onChange(updateField, {
          value:new Date(actualEndTime),
        });
      }
    }
}
  useEffect(() => {
    const start = props.valueGetter('Start');
    if(start && shiftLength){
      const end = moment(start).add(shiftLength, 'minutes').format();
        props.onChange('End', {
      value: new Date(end),
    });
    }
  },[shiftLength])

  const changeZipCode = async () => {
    const zipCode = props.valueGetter('PatientZipCode');
    if (zipCode && zipCode.length < 5) return;

    const zipCodeDetail = await dispatch(
      getZipCodeInfo(config.baseUrl, zipCode)
    );

    props.onChange('PatientState', {
      value: zipCodeDetail.state ?? '',
    });
    props.onChange('PatientCity', {
      value: zipCodeDetail.city ?? '',
    });
  };

  const billingRate = async () => {
    const appointmentType = props.valueGetter('AppointmentType');
    const startDateTime = props.valueGetter('Start')
    let locationId = 0;
    let jobCategoryId = 0;
    const appointmentFiltteredData = appointmentData?.find(item => item?.id === appointmentType) ;
    if(appointmentFiltteredData && appointmentFiltteredData?.shiftLength ){
      props.onChange('ShiftLength', {
        value: appointmentFiltteredData?.shiftLength,
      });
    }
    if (locationNameInfo?.id && jobCategory?.id) {
      locationId = locationNameInfo.id;
      jobCategoryId = jobCategory.id;
    } else if (
      jobInfoForDailyOccurance &&
      jobInfoForDailyOccurance.length &&
      jobInfoForDailyOccurance[0].locationId &&
      jobInfoForDailyOccurance[0].employerJobCategoriesIdList
    ) {
      locationId = jobInfoForDailyOccurance[0].locationId;
      jobCategoryId =
        jobInfoForDailyOccurance[0].employerJobCategoriesIdList[0]
          .jobCategoryId;
    }
    
    const encounterRate = await dispatch(
      getEncounterRate(config.baseUrl, {
        appointmentTypeId: appointmentType,
        locationId: locationId,
        jobCategoryId: jobCategoryId,
        shiftDateTime:`${moment(startDateTime).format("YYYY-MM-DDTHH:mm:ss")}Z`
      })
    );
    if(!parseInt(encounterRate?.billingRate)){
      props.onChange('billingRate', {
        value:"",
      });
      Toasts.error(`Please add the billing rate`)
      return
    } else {
      props.onChange('billingRate', {
        value: encounterRate.billingRate,
      });
    }
   
  };
  const updateShiftLength  = () => {
    const start = props.valueGetter('Start');
    const end = props.valueGetter('End')
    updateShiftTime({currentValue:end, updateField:"ShiftLength",shiftStartTime:start,masterData:shiftLengthData})
  }
  const updateShiftEndTime = () => {
    const shiftLength = props.valueGetter('ShiftLength') ?? 15
    const start = props.valueGetter('Start');
    updateShiftTime({currentValue:shiftLength?.id, updateField:"End",shiftStartTime:start,masterData:[]})
  }

  return (
    <FormElement horizontal={false} style={{ justifyContent: 'none' }}>
      {/* <div className="k-form-field">
        <Label>Title</Label>
        <div className="k-form-field-wrap">
          <Field
            name={'Title'}
            component={props.titleEditor || Input}
            as={Input}

            // format="t"
          />
        </div>
      </div> */}
      <div className="k-form-field">
        <Label>Appointment Type <span className='required'>* </span></Label>
        <div className="k-form-field-wrap">
          <Field
            name={'AppointmentType'}
            component={AppointmentType}
            onChange={billingRate}
          />
          {props.errors.AppointmentType && (
            <Error>{props.errors.AppointmentType}</Error>
          )}
        </div>
      </div>

      <div
        style={{
          width: '100%',
        }}
      >
        <div className="kendo-custom-field">
          <div className="k-form-field" style={{ width: '50%' }}>
            <Label>Start <span className='required'>* </span></Label>
            <div className="k-form-field-wrap">
              <Field
                // disabled={true}
                name={'Start'}
                component={props.startEditor || DatePicker}
                as={DateTimePicker}
                rows={1}
                width={'240px'}
                onChange={updateShiftEndTime}
                // onChange={changeEndDate}
                // format="t"
              />
                {props.errors.Start && (
                <Error>{props.errors.Start}</Error>
              )}
            </div>
          </div>
          <div className="k-form-field" style={{ width: '50%' }}>
            <Label>Shift Length  <span className='required'>* </span></Label>
            <div className="k-form-field-wrap">
              <Field
                name={'ShiftLength'}
                component={ShiftLength}
                // onChange={changeEndDate}
              />
              {props.errors.ShiftLength && (
                <Error>{props.errors.ShiftLength}</Error>
              )}
            </div>
          </div>
        </div>
        <div className="kendo-custom-field">
          <div className="k-form-field" style={{ width: '50%' }}>
            <Label>End  <span className='required'>* </span></Label>
            <div className="k-form-field-wrap">
              <Field
                name={'End'}
                component={props.endEditor || DatePicker}
                as={DateTimePicker}
                rows={1}
                width={'240px'}
                onChange={updateShiftLength}
                // format="t"
              />
               {props.errors.End && (
                <Error>{props.errors.End}</Error>
              )}
            </div>
          </div>
          <div className="k-form-field" style={{ width: '50%' }}>
            <Label>Billing Rate  <span className='required'>* </span></Label>
            <div className="k-form-field-wrap">
              <Field
                name={'billingRate'}
                component={Input}
                as={Input}
                disabled={true}
              />
              {props.errors.billingRate && (
                <Error>{props.errors.billingRate}</Error>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="k-form-field">
        <Label>Patient Name  <span className='required'>* </span></Label>
        <div className="k-form-field-wrap">
          <Field name={'PatientName'} component={Input} as={Input} />
          {props.errors.PatientName && (
            <Error>{props.errors.PatientName}</Error>
          )}
        </div>
      </div>
      <div className="k-form-field">
        <Label>Patient Phone  <span className='required'>* </span></Label>
        <div className="k-form-field-wrap">
          <Field name={'PatientPhone'} component={PhoneNumberInput} />
          {props.errors.PatientPhone && (
            <Error>{props.errors.PatientPhone}</Error>
          )}
        </div>
      </div>
      <div className="k-form-field">
        <Label>Patient Street Address  <span className='required'>* </span></Label>
        <div className="k-form-field-wrap">
          <Field name={'PatientStreetAddress'} component={Input} as={Input} />
          {props.errors.PatientStreetAddress && (
            <Error>{props.errors.PatientStreetAddress}</Error>
          )}
        </div>
      </div>
      <div className="k-form-field">
        <Label>Patient Zip Code  <span className='required'>* </span></Label>
        <div className="k-form-field-wrap">
          <Field
            name={'PatientZipCode'}
            component={ZipCodeInput}
            onChange={changeZipCode}
          />
          {props.errors.PatientZipCode && (
            <Error>{props.errors.PatientZipCode}</Error>
          )}
        </div>
      </div>
      <div className="k-form-field">
        <Label>Patient State  <span className='required'>* </span></Label>
        <div className="k-form-field-wrap">
          <Field name={'PatientState'} component={Input} as={Input} />
          {props.errors.PatientState && (
            <Error>{props.errors.PatientState}</Error>
          )}
        </div>
      </div>
      <div className="k-form-field">
        <Label>Patient City  <span className='required'>* </span></Label>
        <div className="k-form-field-wrap">
          <Field name={'PatientCity'} component={Input} as={Input} />
          {props.errors.PatientCity && (
            <Error>{props.errors.PatientCity}</Error>
          )}
        </div>
      </div>
      {/* <div className="k-form-field">
        <Label>Patient Location Map</Label>
        <div className="k-form-field-wrap">
          <Field name={'MapDetails'} component={ShowMap} />
        </div>
      </div> */}
    </FormElement>
  );
};
